import { browser } from '$app/environment';
import { awsInit } from '$lib/aws/aws-init';
import { useLocalCache } from '$lib/local-cache/local-cache';
import { GRAPHQL_AUTH_MODE, type GraphQLQuery } from '@aws-amplify/api';
import { API } from 'aws-amplify';
import { writable } from 'svelte/store';

awsInit();

export interface AllSource {
	name: string;
	id: number;
}

// leave undefined under, we need check at layout
const allSources = writable<AllSource[]>();

export const useAllSources = () => {
	return { allSources };
};

if (browser) {
	// cache 24h
	const lc = useLocalCache<AllSource[]>('chessat3-all-sources', 1000 * 60 * 60 * 24);

	const lcd = lc.invoke();
	if (lcd) {
		allSources.set(lcd);
	} else {
		API.graphql<GraphQLQuery<any>>({
			query: /* GraphQL */ `
				query AllPgSources($orderBy: [PgSourcesOrderBy!], $filter: PgSourceFilter) {
					allPgSources(orderBy: $orderBy, filter: $filter) {
						nodes {
							nodeId
							id
							name
							isVisible
							sortBy
							useOnRegistration
						}
					}
				}
			`,
			variables: {
				orderBy: 'NAME_ASC',
				filter: { useOnRegistration: { _eq: true } }
			},
			authMode: GRAPHQL_AUTH_MODE.API_KEY
		}).then((d) => {
			const items = d.data.allPgSources.nodes.map((item: any) => ({
				name: item.name,
				id: item.id
			})) as AllSource[];

			allSources.set(items);
			lc.set(items);
		});
	}
}
